import { MapPin } from "lucide-react";
import { ITINERARIES, DRIVE_TIMES, IMAGES } from "@/data/property";
import { Reveal, MaskLineInView } from "./Reveal";

export default function Location() {
  return (
    <section id="location" data-testid="location-section" className="bg-[#0E2A47] relative overflow-hidden py-24 md:py-32">
      <div className="grain-overlay" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-3xl mb-16">
          <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">Location & Neighborhood</span>
          <h2 className="mt-3 font-display font-semibold text-white text-4xl md:text-7xl tracking-tight leading-[0.95]">
            <MaskLineInView>On the shores of</MaskLineInView>
            <MaskLineInView delay={0.1}>
              <span className="font-serif-accent italic font-normal text-[#1FB6C9]">Canyon Lake.</span>
            </MaskLineInView>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Itineraries - numbered manifesto chapters */}
          <div className="lg:col-span-2 space-y-10">
            {ITINERARIES.map((it, i) => (
              <Reveal key={it.n} delay={i * 0.1}>
                <div className="flex gap-6 md:gap-10 border-t border-white/15 pt-8">
                  <span className="font-serif-accent italic text-4xl md:text-5xl text-[#1FB6C9] shrink-0">
                    {it.n}
                  </span>
                  <div>
                    <h3 className="font-display font-medium text-2xl md:text-3xl text-white">{it.title}</h3>
                    <p className="mt-3 text-white/70 font-body text-lg leading-relaxed max-w-xl">{it.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Drive times */}
          <Reveal delay={0.15}>
            <div className="rounded-lg bg-white/5 border border-white/10 p-8 backdrop-blur-sm lg:sticky lg:top-28">
              <div className="flex items-center gap-2 text-[#1FB6C9] mb-6">
                <MapPin size={18} />
                <span className="text-sm uppercase tracking-widest font-body">Drive Times</span>
              </div>
              <ul className="space-y-4">
                {DRIVE_TIMES.map((d) => (
                  <li key={d.place} className="flex items-center justify-between border-b border-white/10 pb-4 last:border-0">
                    <span className="text-white/85 font-body">{d.place}</span>
                    <span className="font-display font-medium text-[#1FB6C9]">{d.time}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 overflow-hidden rounded-lg">
                <img src={IMAGES.sunsetDeck} alt="Upper deck with plunge pool and Canyon Lake sunset views" className="w-full h-40 object-cover" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
